<template>
    <li>
        <div>
            <p class="sm-text font-weight-normal"><em>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</em></p>
        </div>

        <div class="mb-3">
            <support-ticket-previous-reply/>

            <support-ticket-new-reply/>

            <div class="text-right">
                <span class="pr-3"><i class="far fa-reply align-middle"></i>Reply</span>

                <span class="pr-3"><i class="far fa-pause-circle align-middle"></i>Place on Hold</span>

                <span class="pr-3"><i class="far fa-envelope align-middle"></i>Keep Unread </span>

                <span class="pr-3"><i class="far fa-archive align-middle"></i>Archive Ticket</span>
            </div>
        </div>
    </li>
</template>

<script>
    import SupportTicketPreviousReply from "../components/SupportTicketPreviousReply";
    import SupportTicketNewReply from "../components/SupportTicketNewReply";

    export default {
        components: {
            SupportTicketPreviousReply, SupportTicketNewReply
        },

        name: 'SupportMessageListItem',

        methods: {
            action: function () {
                this.$emit('action');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/variables';

    li {
        padding: 15px 20px 25px;
        border-bottom: 1px solid #e7e7e7;
        cursor: pointer;

        .sm-text {
            font-size: 12px;
        }

        .title {
            font-size: 15px;
            font-weight: bold;
        }

        i {
            font-size: $list-icon-size;
            margin-right: $list-icon-margin-right;
        }

        &:hover {
            background-color: white;
        }

        &:last-child, &:only-child {
            border-bottom: none;
        }
    }
</style>
